import { Event } from "../../../../../Global/Base/Events";
import { ICompositeComponent, IGenericControl, IHasEncryptionState } from "../../Controls/ControlInterfaces";
import { ILoader } from "../../ILoader";
import { IFormControl } from "../FormControl";
import { IFrameWithChildFrames, IMasterableFrame } from "./FrameInterfaces";
import { IDetailMasterableFrame } from "./IDetailMasterableFrame";
import { IEditableFrame } from "./IEditableFrame";

export interface ITwoListFrame extends IFormControl, IHasEncryptionState, ILoader, IGenericControl, ICompositeComponent, IDetailMasterableFrame, IFrameWithChildFrames {
    readonly isTwoListFrame: boolean;
    /**
     * Vrací, zda je předaný frame přímou subkomponentou TLF
     */
    isSubframe(frame: IMasterableFrame): boolean;

    /**
     * Událost volaná změnou editačního režimu
     */
     readonly editModeChanged: Event<IEditableFrame, boolean>;
}

export class ITwoListFrame {
    private static _properties: (keyof ITwoListFrame)[] = ["isTwoListFrame", "editModeChanged"];

    private static _methods: (keyof ITwoListFrame)[] = [
        "isSubframe",
    ];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null &&
            !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
